import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { CombinatoriaRow } from "./CombinatoriaRow";
import { CombinatoriaI } from "interfaces/Combinatoria";

interface Props {
  elementos: CombinatoriaI[];
  renderActions?: (elemento: CombinatoriaI) => ReactNode;
}

export const CombinatoriaTable = ({ elementos = [], renderActions }: Props) => {
  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Modalidad</th>
            <th>Nivel</th>
            <th>Opción Pedagógica</th>
            {renderActions && <th className="text-center">Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <CombinatoriaRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={renderActions}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 9 : 8}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay combinatorias para visualizar.</b> Para poder
                  visualizar combinatorias debes <br /> seleccionar el botón
                  agregar «Nueva Combinatoria».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
